export const NAMESPACE = "AUTH";